import React from 'react';
import { Link } from 'react-router-dom';

/*
 * Placeholder for an article that is written but not yet cleared.
 *
 * The pages behind this exist and their URLs are live, because the footer's
 * credit lines and several in-page links point at them and a dead link is
 * worse than an honest holding page. What is withheld is the content, until
 * CMA and CSO have reviewed the claims (RES-20) and a named clinician is
 * attached to the byline (RES-21).
 *
 * Two things this deliberately does NOT do. It does not say "coming soon",
 * which tells a reader nothing and reads as an unfinished site. And it does
 * not hint at what the article will claim, because the entire reason it is
 * held is that the claims are not signed off.
 *
 * These pages are out of the sitemap while this is showing. A holding page is
 * not a destination and should not be submitted as one.
 */

const ARTICLE_INTRO = 'This one is written and in clinical review. We publish health content only once a registered clinician has checked it and put their name to it, so it is not up yet.';

const UnderReview = ({ title, category, intro = ARTICLE_INTRO }) => (
    <div className="pa2">
        <div className="art">
            <div className="artwrap">
                <div className="crumb">
                    <Link to="/blog">Blog</Link> <span>&rsaquo;</span> {category}
                </div>

                <h1>{title}</h1>

                <p className="stand">{intro}</p>

                <div className="callout" style={{ marginTop: '1.8rem' }}>
                    <b>Why you are seeing this rather than the article.</b> Reviewing after
                    publishing would mean the claims were public before anyone had checked them.
                    Doing it the other way round is slower and it is the right way round.
                </div>

                <p className="lede" style={{ marginTop: '1.6rem' }}>
                    If you need what this covers before it is published, ask us and we will answer
                    directly. That includes anything you are assessing us on formally.
                </p>

                <div className="cta-row" style={{ marginTop: '1.4rem', marginBottom: '2.6rem' }}>
                    <Link className="btn btn-t" to="/contact">Contact us</Link>
                </div>

                <h2 className="srch">In the meantime</h2>
                <div className="rel">
                    <Link className="rc" to="/trust-centre">
                        <span className="cat">Reference</span>
                        <span className="t">Trust centre</span>
                        <span className="x">What an employer sees, what they never will, and how the data is handled.</span>
                    </Link>
                    <Link className="rc" to="/contact">
                        <span className="cat">Tool</span>
                        <span className="t">What MSK Health costs you</span>
                        <span className="x">Published ONS and HSE figures applied to your headcount, with every source shown.</span>
                    </Link>
                </div>
            </div>
        </div>
    </div>
);

export default UnderReview;
